export const VALIDATION_EXPLANATION = {
  conflicts: [{
    explanations: [
      {
        conclusion: '(0P3J9 - Typdefinierende Tonnageklasse 22)',
        condition: '(0P3M8 - NHMR) AND (0T0AI - Typ LKW 05K)',
        ruleId: 'com.ptc.windchill.option.model.ChoiceRule.5624418610:D'
      },
      {
        conclusion: '(0P2UV - CBU-Fahrzeug)',
        condition: '(0P3M8 - NHMR)',
        ruleId: 'com.ptc.windchill.option.model.ChoiceRule.5624969008:D'
      }
    ]
  }],
  relevantChoices: [
    { id2: '0T0DL', name: 'Typ LKW 48F' },
    { id2: '0T0AK', name: 'Typ LKW 06F' },
    { id2: '0PHLH', name: 'D26R6S_CHINA6_L' }
  ]
}

// BOM
export const BOM_VALIDATION_SUCCESS = {
  businessName: 'Pre Serie',
  encodedBusinessName: 'encodedBusinessName',
  componentId: '0DTT',
  endDate: '2021-09-01T05:24:50.727',
  id: '612f0ea1afa31673201d1106',
  planningPeriodRange: { from: 'PP202132', to: 'PP202132' },
  startDate: '2021-09-01T05:24:49.886',
  status: 'SUCCESS',
  user: 'j0000'
}
export const BOM_VALIDATION_PROGRESS = {
  businessName: 'Pre Serie',
  encodedBusinessName: 'encodedBusinessName',
  componentId: '0DTT',
  endDate: '2021-09-01T05:24:50.727',
  id: '612f0ea1afa31673201d1106',
  planningPeriodRange: { from: 'PP202132', to: 'PP202132' },
  startDate: '2021-09-01T05:24:49.886',
  status: 'IN_PROGRESS',
  user: 'j0000'
}
export const BOM_VALIDATION_FAILED = {
  businessName: 'Prototyp',
  encodedBusinessName: 'encodedBusinessName',
  componentId: '01VP',
  endDate: '2021-09-01T05:29:14.239',
  id: '612f0f95afa31673201d1107',
  planningPeriodRange: { from: 'PP202204', to: 'PP202204' },
  startDate: '2021-09-01T05:28:53.88',
  status: 'FAILED',
  user: 'z9999'
}
export const BOM_VALIDATION_IN_PROGRESS = {
  businessName: 'Freigabe Serie',
  componentId: '02NS',
  endDate: '2021-09-01T06:00:40.433',
  id: '612f16ddafa31673201d1108',
  planningPeriodRange: { from: 'PP202132', to: 'PP202132' },
  startDate: '2021-09-01T05:59:57.37',
  status: 'SUCCESS',
  user: 'y8787'
}
export const BOM_VALIDATIONS = [BOM_VALIDATION_SUCCESS, BOM_VALIDATION_FAILED, BOM_VALIDATION_IN_PROGRESS]
export const AMBIGUOUS_ELEMENTS = [{
  ambiguous1Id2: 'KV.#032N-1012',
  ambiguous1Name: 'Scheibner.',
  ambiguous2Id2: '81.#032N-0623',
  ambiguous2Name: 'PT-KV T23111',
  explanation: '(0P3BI - 8x4) AND (0PH4R - Modeller 2023)',
  rangeFrom: 'PP202413',
  rangeTo: 'PP202413'
}, {
  ambiguous1Id2: 'KV.#032N-1012',
  ambiguous1Name: 'Scheibner.',
  ambiguous2Id2: '81.#032N-0623',
  ambiguous2Name: 'PT-KV T23111',
  explanation: '(0P3BI - 8x4) OR (0PH4R - Modeller 2023)',
  rangeFrom: 'PP202413',
  rangeTo: 'PP202413'
},
{
  ambiguous1Id2: 'KV.#032N-2222',
  ambiguous1Name: 'Scheibner.',
  ambiguous2Id2: '81.#032N-0623',
  ambiguous2Name: 'PT-KV T23111',
  explanation: '(0P3BI - 8x4) AND (0PH4R - Modeller 2023)',
  rangeFrom: 'PP202413',
  rangeTo: 'PP202413'
}]
export const UNUSED_ELEMENTS = [
  {
    componentOid: 'wt.part.WTPart:6708107097',
    id2: '81.#000Q-1080',
    name: 'Rahmen-HT 4x2 R4450/2100 BL/LL NBA 8 mm',
    oid: 'wt.part.WTPart:5181762353',
    rangeFrom: 'PP202636',
    rangeTo: 'PP202636'
  },
  {
    componentOid: 'wt.part.WTPart:6708107097',
    id2: '81.#000Q-0469',
    name: 'Rahmen-HT R5075/2375 BL NBA 26t',
    oid: 'wt.part.WTPart:5087916194',
    rangeFrom: 'PP202636',
    rangeTo: 'PP202636'
  }
]
export const INCOMPLETE_ELEMENTS = [
  { rangeFrom: 'PP202205', rangeTo: 'PP202205', explanation: '(0P3JF - Typdefinierende Tonnageklasse 33)' },
  { rangeFrom: 'PP202205', rangeTo: 'PP202205', explanation: '(0P1SG - Stoßfänger, Stahl, 3-teilig) ' }
]
export const BOM_VALIDATION_RESULTS = {
  componentVariant: {
    ambiguousElements: AMBIGUOUS_ELEMENTS,
    unusedElements: UNUSED_ELEMENTS,
    incompleteElements: INCOMPLETE_ELEMENTS
  },
  solutionElement: { ambiguousElements: [], unusedElements: [UNUSED_ELEMENTS[0]], incompleteElements: [] },
  transformation: { ambiguousElements: [], unusedElements: [], incompleteElements: [INCOMPLETE_ELEMENTS[1]] }
}

// Test cases
export const TEST_CASE_FILE = { name: 'Test_Case.v2.xlsx' }
export const TEST_CASE_FILENAME = 'Test_Case.v2'
export const TEST_CASES = [
  {
    id: '5ffd9484adf9e108a6374910',
    createdDate: '2021-01-12T12:22:27.987',
    creator: 'g2222',
    name: '21F 315 60',
    isPinned: true,
    expireDate: null
  },
  {
    id: '601430dc5fd04968cb68d8db',
    createdDate: '2021-01-29T15:59:23.92',
    creator: 'o3333',
    name: 'GFZ, positiv (auslösbar)'
  },
  {
    id: '608ffd75097b826febea3349',
    createdDate: '2021-05-03T13:41:09.401',
    creator: 'z9999',
    name: '20210414_naafs'
  }
]
export const TEST_CASE_VALIDATION_RESULTS = [
  {
    id: 4,
    logicalExpression: '5.300 mm Hauptradstand AND Nebenabtrieb, motorabhängig, schaltbar',
    testCaseValidationStatus: 'FAILED',
    planningPeriodRange: { from: 'PP202205', to: 'PP202205' }
  },
  {
    id: 5,
    logicalExpression: '',
    testCaseValidationStatus: 'SUCCESS',
    planningPeriodRange: { from: 'PP202205', to: 'PP202205' }
  }
]
export const TEST_CASE_VALIDATIONS = [
  {
    id: '6176701063667926a3486fe7',
    planningPeriodRange: { from: 'PP202205', to: 'PP202205' },
    status: 'PROCESSED',
    testCaseId: '61766ff563667926a3486fe6',
    validationDate: '2021-10-25T08:51:28.695',
    validationResults: null,
    businessName: 'Freigabe Serie',
    encodedBusinessName: 'RnJlaWdhYmUgU2VyaWU='
  },
  {
    id: '6176710e63667926a3486fe8',
    planningPeriodRange: { from: 'PP202205', to: 'PP202205' },
    status: 'FAILED',
    testCaseId: '61766ff563667926a3486fe6',
    validationDate: '2021-10-25T08:55:42.96',
    validationResults: null,
    businessName: 'Pre Serie',
    encodedBusinessName: 'UHJlIFNlcmll'
  },
  {
    id: '61766de563667926a3486fe3',
    planningPeriodRange: { from: 'PP202205', to: 'PP202205' },
    status: 'IN_PROGRESS',
    testCaseId: '61766dc263667926a3486fe1',
    validationDate: '2021-10-25T08:42:11.4',
    validationResults: null,
    businessName: 'Pre Serie',
    encodedBusinessName: 'UHJlIFNlcmll'
  }
]
export const TEST_CASE_VALIDATION_RESULT_EXPLANATION = {
  conflicts: [
    {
      explanations: [
        {
          condition: '((0P3M8 - NHMR) AND ((0P3BF - 8x2=4) OR (0P3BG - 8x2-4) OR (0P3BJ - 8x4/4)))',
          conclusion: 'NOT (0P1TN - Elektronisches Stabilitätsprogramm (ESP))',
          ruleId: 'com.ptc.windchill.option.model.ChoiceRule.5411921914:C'
        },
        {
          condition: '((0P3M8 - NHMR) AND (0T0DG - Typ LKW 92F)) AND ((PP202110) OR (PP202111) OR (PP202112)))',
          conclusion: '((0P2TS - Bauart, normalhoch) AND (0P2UV - CBU-Fahrzeug)',
          ruleId: 'com.ptc.windchill.option.model.ChoiceRule.5624632330:D'
        },
        {
          condition: '((0P3M8 - NHMR) AND NOT (0T0DG - Typ LKW 92F)) OR ((0P3M8 - NHMR) P202136)))',
          conclusion: 'NOT (0P1TO - Ohne Elektronisches Stabilitätsprogramm (ESP))',
          ruleId: 'com.ptc.windchill.option.model.ChoiceRule.4923024201:D'
        }
      ]
    }
  ],
  relevantChoices: [
    { id2: '0P3BJ', name: '8x4/4' },
    { id2: '0P3BM', name: '8x6' },
    { id2: '0P1TO', name: 'Ohne Elektronisches Stabilitätsprogramm (ESP)' }
  ]
}

export const NOT_USABLE_CHOICES_COMPARISON_DYNAMIC_COLUMNS = [
  {
    name: 'UHJlIFNlcmllPP202415',
    label: 'Pre Serie PP202415',
    field: 'UHJlIFNlcmllPP202415',
    align: 'center',
    style: 'min-width: 200px;',
    checked: true,
    isDynamic: true,
    numberOfStateChanges: 0
  },
  {
    name: 'UHJlIFNlcmllPP202428',
    label: 'Pre Serie PP202428',
    field: 'UHJlIFNlcmllPP202428',
    align: 'center',
    style: 'min-width: 200px;',
    isDynamic: true,
    checked: true,
    numberOfStateChanges: 0
  },
  {
    name: 'UHJlIFNlcmllPP202501',
    label: 'Pre Serie PP202501',
    field: 'UHJlIFNlcmllPP202501',
    align: 'center',
    style: 'min-width: 200px;',
    isDynamic: true,
    checked: true,
    numberOfStateChanges: 2
  }
]

export const NOT_USABLE_CHOICES_COMPARISON_RESULTS = {
  headers: [
    {
      productModelName: 'Pre Serie',
      planningPeriod: 'PP202419',
      headerKey: 'UHJlIFNlcmllPP202419',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Pre Serie',
      planningPeriod: 'PP202415',
      headerKey: 'UHJlIFNlcmllPP202415',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Pre Serie',
      planningPeriod: 'PP202428',
      headerKey: 'UHJlIFNlcmllPP202428',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Pre Serie',
      planningPeriod: 'PP202501',
      headerKey: 'UHJlIFNlcmllPP202501',
      numberOfStateChangesAcrossAValidationComparison: 2
    },
    {
      productModelName: 'Pre Serie',
      planningPeriod: 'PP202513',
      headerKey: 'UHJlIFNlcmllPP202513',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Freigabe Serie',
      planningPeriod: 'PP202415',
      headerKey: 'RnJlaWdhYmUgU2VyaWU=PP202415',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Freigabe Serie',
      planningPeriod: 'PP202419',
      headerKey: 'RnJlaWdhYmUgU2VyaWU=PP202419',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Freigabe Serie',
      planningPeriod: 'PP202428',
      headerKey: 'RnJlaWdhYmUgU2VyaWU=PP202428',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Freigabe Serie',
      planningPeriod: 'PP202501',
      headerKey: 'RnJlaWdhYmUgU2VyaWU=PP202501',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Freigabe Serie',
      planningPeriod: 'PP202513',
      headerKey: 'RnJlaWdhYmUgU2VyaWU=PP202513',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Prototyp',
      planningPeriod: 'PP202415',
      headerKey: 'UHJvdG90eXA=PP202415',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Prototyp',
      planningPeriod: 'PP202419',
      headerKey: 'UHJvdG90eXA=PP202419',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Prototyp',
      planningPeriod: 'PP202428',
      headerKey: 'UHJvdG90eXA=PP202428',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Prototyp',
      planningPeriod: 'PP202501',
      headerKey: 'UHJvdG90eXA=PP202501',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Prototyp',
      planningPeriod: 'PP202513',
      headerKey: 'UHJvdG90eXA=PP202513',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Serie',
      planningPeriod: 'PP202419',
      headerKey: 'U2VyaWU=PP202419',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Serie',
      planningPeriod: 'PP202536',
      headerKey: 'U2VyaWU=PP202536',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Serie',
      planningPeriod: 'PP202501',
      headerKey: 'U2VyaWU=PP202501',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Serie',
      planningPeriod: 'PP202513',
      headerKey: 'U2VyaWU=PP202513',
      numberOfStateChangesAcrossAValidationComparison: 0
    },
    {
      productModelName: 'Serie',
      planningPeriod: 'PP202428',
      headerKey: 'U2VyaWU=PP202428',
      numberOfStateChangesAcrossAValidationComparison: 0
    }
  ],
  content: [
    {
      optionId: '0SAG',
      optionName: 'Paket Liegenbereich',
      choiceId: '0PKNE',
      choiceName: 'Ohne Paketierung Liegenbereich',
      cells: [
        { headerKey: 'U2VyaWU=PP202419', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202536', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202501', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202513', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202428', value: 'MISSING_DATA' },
        { headerKey: 'UHJlIFNlcmllPP202501', value: 'IS_NOW_USABLE' }
      ],
      numberOfStateChangesForChoiceAcrossComparedValidations: 1
    },
    {
      optionId: '0KNQ',
      optionName: 'Reifen NLA hlaufachse Pirelli 385/55R22hlaufachse Pirelli 385/55R22',
      choiceId: '0PHE7',
      choiceName: 'Reifen Nachlaufachse Pirelli 385/55R22,5 FH:01 Profuel Lenk-Sonder TL',
      cells: [
        { headerKey: 'U2VyaWU=PP202419', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202536', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202501', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202513', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202428', value: 'MISSING_DATA' },
        { headerKey: 'UHJlIFNlcmllPP202501', value: 'IS_NOW_NOT_USABLE' }

      ],
      numberOfStateChangesForChoiceAcrossComparedValidations: 1
    },
    {
      optionId: '0KNQ',
      optionName: 'Reifen NLA',
      choiceId: '0PHE8',
      choiceName: 'Reifen Nachlaufachse Pirelli 385/55R22,5 FH:01 II Lenk-Fern TL',
      cells: [
        { headerKey: 'U2VyaWU=PP202419', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202536', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202501', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202513', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202428', value: 'MISSING_DATA' }
      ],
      numberOfStateChangesForChoiceAcrossComparedValidations: 0
    },
    {
      optionId: '0KNQ',
      optionName: 'Reifen NLA',
      choiceId: '0PHFB',
      choiceName: 'Reifen Nachlaufachse Pirelli 315/80R22,5 FH:01 COACH Lenk-Fern TL',
      cells: [
        { headerKey: 'U2VyaWU=PP202419', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202536', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202501', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202513', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202428', value: 'MISSING_DATA' }
      ],
      numberOfStateChangesForChoiceAcrossComparedValidations: 0
    },
    {
      optionId: '0KNQ',
      optionName: 'Reifen NLA',
      choiceId: '0PHFJ',
      choiceName: 'Reifen Nachlaufachse Pirelli 315/70R22,5 FH:01 Proway Lenk-Fern TL',
      cells: [
        { headerKey: 'U2VyaWU=PP202419', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202536', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202501', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202513', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202428', value: 'MISSING_DATA' }
      ],
      numberOfStateChangesForChoiceAcrossComparedValidations: 0
    },
    {
      optionId: '0KNQ',
      optionName: 'Reifen NLA',
      choiceId: '0PHVI',
      choiceName: 'Reifen Nachlaufachse Bridgestone 295/60R22,5 DURAVIS R-DRIVE 002 Antrieb-Nah TL',
      cells: [
        { headerKey: 'U2VyaWU=PP202419', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202536', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202501', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202513', value: 'MISSING_DATA' },
        { headerKey: 'U2VyaWU=PP202428', value: 'MISSING_DATA' }
      ],
      numberOfStateChangesForChoiceAcrossComparedValidations: 0
    }
  ]
}

export const TEST_CASES_COMPARISON_RESULTS = {
  mainValidationId: '670e918085f36b28050af817',
  comparedValidationId: '66b23a102799e45a18c6cd80',
  comparisonResults: [
    {
      id: 4,
      logicalExpression: '',
      mainTestCaseValidationStatus: 'SUCCESS',
      comparedTestCaseValidationStatus: 'SUCCESS',
      mainPlanningPeriodRange: {
        from: 'PP202401',
        to: 'PP202436'
      },
      comparedPlanningPeriodRange: {
        from: 'PP202401',
        to: 'PP202436'
      }
    },
    {
      id: 5,
      logicalExpression: '',
      mainTestCaseValidationStatus: 'SUCCESS',
      comparedTestCaseValidationStatus: 'SUCCESS',
      mainPlanningPeriodRange: {
        from: 'PP202401',
        to: 'PP202436'
      },
      comparedPlanningPeriodRange: {
        from: 'PP202401',
        to: 'PP202436'
      }
    },
    {
      id: 6,
      logicalExpression: '',
      mainTestCaseValidationStatus: 'SUCCESS',
      comparedTestCaseValidationStatus: 'FAILED',
      mainPlanningPeriodRange: {
        from: 'PP202401',
        to: 'PP202436'
      },
      comparedPlanningPeriodRange: {
        from: 'PP202401',
        to: 'PP202436'
      }
    }
  ]
}
